import { defineComponent as _defineComponent } from 'vue'
import { THGCO2Equivalent } from '@/interfaces/thg/THGCO2Equivalent';
    import { useRoute, useRouter } from 'vue-router/composables';

    interface Props {
        data?: THGCO2Equivalent[];
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'GenericTHGCO2EquivalentTable',
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
        data?: THGCO2Equivalent[];
    };

    const router = useRouter();
    const route = useRoute();

    

    function edit(co2EquivalentId: string) {
        router.push({
            name: 'thgco2equivalent',
            params: { co2EquivalentId: co2EquivalentId, prevRouteName: route.name as string },
        });
    }

return { __sfc: true,router, route, props, edit }
}

})